//Group All SVG
const CLOSE_SVG = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">	<path fill-rule="evenodd" clip-rule="evenodd" d="M14 1.4L12.6 0L7 5.6L1.4 0L0 1.4L5.6 7L0 12.6L1.4 14L7 8.4L12.6 14L14 12.6L8.4 7L14 1.4Z" fill="#999999" /></svg>'
export { default as NotFound403 } from '../../../public/svg/notFound403.svg';
// export { default as CloseSVG } from '../../../public/svg/close.svg';
export { CLOSE_SVG as CloseSVG };
export { default as ArrowDownSVG } from '../../../public/svg/arrow_down.svg';
export { default as CalendarSVG } from '../../../public/svg/calendar.svg';
export { default as ViewSVG } from '../../../public/svg/view.svg';
export { default as LinkedInSVG } from '../../../public/svg/linkedIn.svg';
export { default as TwitterSVG } from '../../../public/svg/twitter.svg';
export { default as FacebookSVG } from '../../../public/svg/facebook.svg';
export { default as TriangleRightSVG } from '../../../public/svg/triangle_right.svg';
export { default as SearchSVG } from '../../../public/svg/search.svg'
export { default as StatsSVG } from '../../../public/svg/stats.svg';
export { default as ShareSVG } from '../../../public/svg/share.svg';
export { default as RepeatSVG } from '../../../public/svg/repeat.svg';
export { default as CopyrightSVG } from '../../../public/svg/copyright.svg'
export { default as NextSVG } from '../../../public/svg/next.svg'
export { default as BackSVG } from '../../../public/svg/back.svg'
export { default as BarToggleSVG } from '../../../public/svg/bar_toggle.svg'
export { default as MaximizeSVG } from '../../../public/svg/maximize.svg'
export { default as SpinnerSVG } from '../../../public/svg/spinner.svg'
export { default as TickSVG } from '../../../public/svg/tick.svg'
export { default as ButtonXSVG } from '../../../public/svg/buttonX.svg'
export { default as SwitchViewSVG } from '../../../public/svg/switch.svg'
export { default as Pause } from "../../../public/svg/pause.svg"
export { default as LoopSVG } from "../../../public/svg/loop.svg"
export { default as RewindSVG } from "../../../public/svg/rewind.svg"
export { default as RewindCopySVG } from "../../../public/svg/rewindCopy.svg"
export { default as ShuffleSVG } from "../../../public/svg/shuffle.svg"
export {default as SettingSvg} from "../../../public/svg/settings-circle.svg"
export {default as ProssingError} from "../../../public/svg/video_processing.svg"
export {default as Replay} from "../../../public/svg/Replay.svg"
export {default as IndicatorSVG} from "../../../public/svg/indicator.svg"
export {default as Playliste} from "../../../public/svg/Playliste.svg"
export {default as LiveSVG} from "../../../public/svg/live.svg"
export {default as HandicapADSVG} from "../../../public/svg/AD.svg"
export {default as InfoSVG} from "../../../public/svg/info.svg" 